import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from "clsx";
import { Badge, IconButton} from "@material-ui/core";
import "./notificationBell.css";
import NotificationsIcon from '@material-ui/icons/Notifications';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';

const NotificationBell = ({notificationCount, onClick}) => {
    const [animationActive, setAnimationActive] = useState(false);

    useEffect(() => {
        notificationCount > 0 ? setAnimationActive(true) : setAnimationActive(false);
    }, [notificationCount]);

    return (
        <div className="wrapper">
            <Badge badgeContent={notificationCount} color="primary">
                <IconButton size="small" onClick={onClick}>
                    <div className={clsx("bell", { "pulsingOpacity": animationActive})}>
                        <div className={clsx("anchor layer-1",  {
                            "trigger-animation-layer1": animationActive
                            })}
                        >
                            <NotificationsActiveIcon />
                        </div>
                        <div className={clsx("anchor layer-2",  {
                            "trigger-animation-layer2": animationActive
                            })}
                        >
                            <NotificationsIcon />
                        </div>
                        <div className={clsx("anchor layer-3",  {
                            "trigger-animation-layer3": animationActive
                            })}
                        >
                            <NotificationsIcon />
                        </div>
                    </div>
                </IconButton>
            </Badge>
        </div>
    );
};

NotificationBell.propTypes = {
    notificationCount: PropTypes.number,
    onClick: PropTypes.func
};

export default NotificationBell;
